import { MapPinIcon } from "@heroicons/react/24/outline";
import { computeDirectionsUrl } from "helpers/address";
import React from "react";
import {
    ContactValueRow,
    contactValueLinkClasses,
    stopClickPropagation,
} from "./display-row";

interface AddressDisplayProps {
    value: string | null;
}

export const AddressDisplay: React.FC<AddressDisplayProps> = props => {
    const { value } = props;

    if (!value) {
        return null;
    }

    return (
        <ContactValueRow Icon={MapPinIcon}>
            <a
                href={computeDirectionsUrl(value, "")}
                target="_blank"
                rel="noreferrer"
                title={value}
                onClick={stopClickPropagation}
                className={contactValueLinkClasses}>
                {value}
            </a>
        </ContactValueRow>
    );
};
